<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <SearchXRFInspExpForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SearchXRFInspExpForm from '@/components/organisms/terminal/form/SearchXRFInspExpForm.vue'

export default {
  name: 'SearchXRFInspExpDate',

  components: {
    SearchXRFInspExpForm,
  },
}
</script>
